var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoZinli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_340_19334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.558 14H5.99805L9.04257 10.6573H15.558C15.8024 10.6573 16 10.8497 16 11.0895V13.5753C16 13.8101 15.7998 14 15.558 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3898 0H1.87206C1.62767 0 1.43007 0.192363 1.43007 0.424697V2.91042C1.43007 3.15025 1.63027 3.34261 1.87206 3.34261H9.07128L0.109304 13.293C-0.14029 13.5703 0.0651052 14 0.447296 14H3.61662C3.74141 14 3.86621 13.95 3.95461 13.8501L15.7921 0.706995C16.0495 0.429693 15.8441 0 15.4541 0H13.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_340_19334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZinli);
export default __webpack_public_path__ + "static/media/logo-zinli.3bd509669c0746bb407e48b946c78c64.svg";
export { ForwardRef as ReactComponent };